import { useGeolocation } from 'react-use';

import { Flex, Skeleton, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { LocationSelectorSheet } from '@/features/LocationSelectorSheet';

import { getLocationType } from '@/shared/helpers/utils';
import useAppStore from '@/shared/store/app.store.ts';
import { useSettingsStore } from '@/shared/store/settings.store.ts';
import IconMapPin from '@/shared/uikit/assets/icons/IconMapPin.svg?react';
import { LayoutRow } from '@/shared/uikit/layouts/LayoutRow/ui/LayoutRow';

export const Location = () => {
	const geolocation = useGeolocation();
	const isMobile = useAppStore((state) => state.isMobile);
	// const location = useAppStore((state) => state.location);
	const location = useSettingsStore((state) => state.location);

	const [openedLocationSelector, { close: closeLocationSelector, open: openLocationSelector }] =
		useDisclosure(false);

	return (
		<Skeleton visible={!location}>
			<LayoutRow type={isMobile ? 'bottom' : 'once'} onClick={openLocationSelector}>
				<Flex
					id="location-widget"
					align="center"
					justify="space-between"
					style={{ cursor: 'pointer' }}
				>
					<Flex direction="column">
						<Text size="md" fw={600} mt={isMobile ? 10 : 0}>
							{location
								? location.route
										?.filter((item) => getLocationType(item.type.name) !== 'floor')
										.map((item) => item.name)
										.join(' • ')
								: 'Необходимо указать локацию'}
						</Text>
						<Text c="dimmed" size="sm" fw={500}>
							{location &&
								location.route
									?.filter((item) => getLocationType(item.type.name) === 'floor')
									.map((item) => item.name)
									.join(' • ')}
						</Text>
					</Flex>
					<Flex align="center">
						<IconMapPin width={24} />
					</Flex>
				</Flex>
			</LayoutRow>

			<LocationSelectorSheet
				title="Локация"
				open={openedLocationSelector}
				close={closeLocationSelector}
			/>
		</Skeleton>
	);
};
